import React from 'react';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallText from '../../../common-components/common-small-text';

const Numbers = () => {
    return (
        <ScrollAnimation delay={0} animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper smallPaddings={true} className="krdv-numbers">
                <div className="krdv-numbers__wrapper">
                    <CommonTitle className="krdv-numbers__title">Цифры</CommonTitle>
                    <div className="krdv-numbers__data-container">
                        <ScrollAnimation
                            delay={100}
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="krdv-numbers__data-item"
                        >
                            <div className="krdv-numbers__data-title">11</div>
                            <CommonSmallText className="krdv-numbers__data-subtitle">
                                субъектов, по которым велась работа
                            </CommonSmallText>
                            <img
                                src="/images/svg/rec/rec-ciphers__data-img1.svg"
                                alt=""
                                className="krdv-numbers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            delay={200}
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="krdv-numbers__data-item"
                        >
                            <div className="krdv-numbers__data-title">+33%</div>
                            <CommonSmallText className="krdv-numbers__data-subtitle">
                                рост поисковой выдачи в&nbsp;Яндексе
                            </CommonSmallText>
                            <img
                                src="/images/svg/rec/rec-ciphers__data-img1.svg"
                                alt=""
                                className="krdv-numbers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                        <ScrollAnimation
                            delay={300}
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="krdv-numbers__data-item"
                        >
                            <div className="krdv-numbers__data-title">+5 500</div>
                            <CommonSmallText className="krdv-numbers__data-subtitle">
                                поискового трафика ежемесячно
                            </CommonSmallText>
                            <img
                                src="/images/svg/rec/rec-ciphers__data-img1.svg"
                                alt=""
                                className="krdv-numbers__data-img"
                                loading="lazy"
                            />
                        </ScrollAnimation>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Numbers;
